import { httpGet, httpPatch, httpPost } from "@/api/connection";
import {
  AiParseEvidenceFn,
  ExportEvidenceListFn,
  GetEvidenceFn,
  GetEvidenceNumbersFn,
  QueryEvidenceFn,
  UpdateEvidenceFn,
} from "./evidence.api.types";

const getEvidence: GetEvidenceFn = async (options, requestOptions) => {
  return await httpGet("/evidence", options, requestOptions);
};

const queryEvidence: QueryEvidenceFn = async (query, requestOptions = {}) => {
  return await httpPost("/evidence/query", query, requestOptions);
};

const updateEvidence: UpdateEvidenceFn = async (options) => {
  const { evidence_id, ...rest } = options;
  return await httpPatch(`/evidence/${evidence_id}`, rest);
};

const exportEvidenceList: ExportEvidenceListFn = async (values) => {
  return await httpPost("/evidence/export", values);
};

const AiParseEvidence: AiParseEvidenceFn = async (values) => {
  return await httpPost("/ai/evidence/parse", values);
};

const getEvidenceNumbers: GetEvidenceNumbersFn = async (query) => {
  return await httpPost("/evidence/evidence-numbers/query", query);
};

export const EvidenceAPI = {
  get: getEvidence,
  query: queryEvidence,
  update: updateEvidence,
  exportEvidenceList: exportEvidenceList,
  AI: {
    parseEvidence: AiParseEvidence,
  },
  getEvidenceNumbers: getEvidenceNumbers,
};
